import { render, staticRenderFns } from "./PainelDashboard.vue?vue&type=template&id=78f65d2e&scoped=true"
import script from "./PainelDashboard.vue?vue&type=script&lang=js"
export * from "./PainelDashboard.vue?vue&type=script&lang=js"
import style0 from "./PainelDashboard.css?vue&type=style&index=0&id=78f65d2e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f65d2e",
  null
  
)

export default component.exports